<ng-container *ngIf="status">
	<div *ngIf="tfa_required" class="alert alert-danger" fxFlex fxLayoutAlign="center" fxLayout="row">
		<mat-icon>warning</mat-icon>
		<h2>Apps die u gebruikt, zijn zo geconfigureerd dat tweefactorauthenticatie vereist is. Nadat je tweefactorauthenticatie hebt uitgeschakeld, kun je niet meer inloggen.</h2>
	</div>
	<p>Voer voordat u doorgaat de code van uw verificatie-app in.</p>
	<form [formGroup]="otpForm">
		<app-otp-input (completed)="submit($event)"></app-otp-input>
		<button color="primary" mat-button [disabled]="!otpForm.valid">BEVESTIGEN</button>
	</form>
</ng-container>
<ng-container *ngIf="!status">
	<div class="alert alert-info" fxFlex fxLayoutAlign="center" fxLayout="row">
		<mat-icon>warning</mat-icon>
		<h2>Twee-factor-authenticatie is niet ingeschakeld op uw account.</h2>
	</div>
</ng-container>
